module.exports = __webpack_public_path__ + "img/tour-1.069aa21d.png";